<template>
    <span class="f fh fa-c o-ol ath-visual-text">
        <VisualIcon v-if="icon"
            :name="icon"
            :uiSize="iconSize"
            class="sm-r-xs"
            :class="[iconCname]" />
        <span class="fg o-ol">{{ uiText }}<slot name="labelAfter"></slot></span>
        <slot name="labelRight"></slot>
    </span>
</template>

<script>
import { isString } from '@aretheyhappy/utils';
import VisualIcon from '../visuals/Icon.vue';

export default {
    name: 'mead-text',
    components: {VisualIcon},
    props: {
        /**
         * Name of an icon to render before the text. Passed through to the
         * `Icon` component. Defaults to `false`, which hides the icon entirely.
         */
        icon        : {type: [Boolean, String], default: () => false},
        /**
         * Additional class(es) applied to the icon, when `icon` is set.
         */
        iconCname   : {type: String, default: () => ''},
        /**
         * Size passed through to the icon's `uiSize` prop (e.g. "s", "m", "l").
         */
        iconSize    : {type: String, default: () => 's'},
        /**
         * The text content to display. Strings are passed through I18N
         * translation; numbers are rendered as-is. Defaults to `false`, which
         * renders as "???".
         */
        text        : {type: [Boolean, String, Number], default: () => false},
    },
    computed: {
        uiText: function () {
            if (this.text === false) return '???';
            else if (isString(this.text)) return MeadCommon.I18N.go(this.text);
            else return this.text;
        },
    },
};
</script>
